<script setup lang="ts">
import IconButton from '@/uiKit/IconButton.vue'
import ToolTip from '@/uiKit/ToolTip.vue'

defineProps<{
  fieldHasGroundTruth?: boolean
}>()

defineEmits<{
  (e: 'lock' | 'lock-mousedown'): void
}>()
</script>

<template>
  <div class="flex size-7 items-center justify-center p-0.5">
    <ToolTip
      :title="
        fieldHasGroundTruth
          ? 'When unlocked, this field will no longer be immutable.'
          : 'Locking a field will prevent it from being recomputed.'
      "
      :offset="2"
      :auto-placement-options="{ allowedPlacements: ['top', 'top-end'] }"
    >
      <IconButton
        aria-label="Lock this field"
        data-lock-field-button
        size="md"
        variant="transparent"
        :icon="fieldHasGroundTruth ? 'lock-fill' : 'unlock'"
        @click="$emit('lock')"
        @mousedown="$emit('lock-mousedown')"
      />
    </ToolTip>
  </div>
</template>
